import { useState } from "react";
import styled, { css } from "styled-components";
import Button from "./Button";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrow-right.svg";
import Title from "../common/Title";
import { useTranslation } from "react-i18next";

const TrainingContent = styled.p``;
const TrainingDetailContainer: any = styled.div`
  padding: 5px 8px;
  position: absolute;
  right: 0;
  background: #f2cdce;
  border: 1px solid #ddb2b9;
  border-radius: 12px 0 0 12px;
  min-height: 300px;
  width: 80px;
  overflow: hidden;
  word-break: keep-all;
  margin: 10px 0;
  transition: width ease-in-out 0.3s;
  z-index: 99;

  > ${TrainingContent} {
    width: 240px;
    height: 240px;
    overflow: auto;
  }

  ${(p: any) =>
    p.active &&
    css`
      width: 240px;
    `}
`;

export default ({ children = [] }: any) => {
  const { t } = useTranslation("games");
  const [active, setActive] = useState(false);

  return (
    <TrainingDetailContainer active={active}>
      <Title>{t("training")}</Title>
      <TrainingContent>{children}</TrainingContent>
      <Button onClick={() => setActive(!active)}>
        {active ? <ArrowRight /> : <ArrowLeft />}
      </Button>
    </TrainingDetailContainer>
  );
};
